import { Pipe, PipeTransform } from '@angular/core';
import { decodeHtmlText } from '../utils/util-master';

@Pipe({ name: 'decodeHtml' })
export class DecodeHtmlPipe implements PipeTransform {
    transform(value: string): string {
        return decodeHtmlText(value);
    }
}
